import { Events, emit } from './store-events.js';
import { attachHoverFocus } from './interactions.js';
import { BaseInteractiveElement } from './component-base.js';

class CardElement extends BaseInteractiveElement {
  constructor() {
    super({ baseClass: 'card', eventGroup: Events.card });
  }
}

try {
  const TAG = 'card';
  if (!customElements.get(TAG)) customElements.define(TAG, CardElement);
  } catch (e) {
  // Fallback: enhance <card> elements without Custom Elements (tag lacks hyphen)
  try {
    const initEl = (el) => {
      try {
        if (!el || el.__cardEnhanced) return;
        el.__cardEnhanced = true;
        try { el.classList && el.classList.add('card'); } catch (_) {}
        const interactive = el.getAttribute('interactive');
        const selectable = el.getAttribute('selectable');
        const href = el.getAttribute('href');
        const isInteractive = interactive === '' || interactive === 'true' || !!href;
        const isSelectable = selectable === '' || selectable === 'true';
        try { if (window.store && window.store.debug) window.store.log('[card:fallback] init', { interactive: isInteractive, selectable: isSelectable, href }); } catch (_) {}
        if (href && isInteractive) { el.setAttribute('role','link'); el.setAttribute('tabindex','0'); }
        else if (isInteractive || isSelectable) { el.setAttribute('role','button'); el.setAttribute('tabindex','0'); }
        const onClick = (ev) => {
          try {
            const innerLink = ev.target && ev.target.closest && ev.target.closest('a,button');
            if (innerLink && el.contains(innerLink)) return;
            if (href) {
              ev.preventDefault(); ev.stopPropagation();
              try { if (window.store && window.store.debug) window.store.log('[card:fallback] click -> navigate', { href }); } catch (_) {}
              try { window.location.assign(href); } catch (_) {}
              emit(Events.card.click, { element: el, href }, el);
              return;
            }
            try { if (window.store && window.store.debug) window.store.log('[card:fallback] click'); } catch (_) {}
            emit(Events.card.click, { element: el }, el);
            if (isSelectable) {
              const selected = el.hasAttribute('data-selected');
              el.toggleAttribute('data-selected', !selected);
              el.setAttribute('aria-pressed', String(!selected));
              try { if (window.store && window.store.debug) window.store.log('[card:fallback] select', { selected: !selected }); } catch (_) {}
              emit(Events.card.select, { element: el, selected: !selected }, el);
            }
          } catch (_) {}
        };
        const onKey = (ev) => { try { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); onClick(ev); } } catch (_) {} };
        if (isInteractive || isSelectable || href) {
          el.addEventListener('click', onClick, true);
          el.addEventListener('keydown', onKey, true);
        }

        // Hover/focus fallback using helper
        try { attachHoverFocus(el, { events: {
          hoverStart: Events.card.hoverStart,
          hoverEnd: Events.card.hoverEnd,
          focus: Events.card.focus,
          blur: Events.card.blur,
          hoverChildStart: Events.card.hoverChildStart,
          hoverChildEnd: Events.card.hoverChildEnd,
        }, ignoreInner: 'a,button' }); } catch (_) {}
      } catch (_) {}
    };
    const enhanceAll = (root = document) => { try { root.querySelectorAll('card').forEach((el) => initEl(el)); } catch (_) {} };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
    } else {
      enhanceAll();
    }
    try {
      const mo = new MutationObserver((muts) => {
        muts.forEach((m) => {
          if (m.addedNodes && m.addedNodes.length) {
            m.addedNodes.forEach((n) => { if (n && n.nodeType === 1) { if (n.matches && n.matches('card')) initEl(n); else if (n.querySelectorAll) enhanceAll(n); } });
          }
        });
      });
      mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
    } catch (_) {}
  } catch (_) {}
}


